module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isDispatch) ? _c('div', [_c('h3', {
    staticClass: "om-page-heading"
  }, [_vm._v("\n    " + _vm._s(_vm.isReturn() ? _vm.$tr('Zwrot zamówienia', 'Order') : '') + "\n    " + _vm._s(_vm.isCollect() ? _vm.$tr('Odbiór zamówienia', 'Order') : '') + "\n    "), _c('router-link', {
    staticClass: "om-link-back",
    attrs: {
      "to": {
        name: ((this.$route.name) + "List")
      }
    }
  }, [_c('i', {
    staticClass: "om-ico-back-link",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n      " + _vm._s(_vm.$tr('wróć', 'Order')) + "\n    ")])], 1), _vm._v(" "), (_vm.order) ? _c('div', {
    staticClass: "om-order"
  }, [_c('ul', {
    staticClass: "om-order__general"
  }, [_c('li', [_c('span', {
    staticClass: "om-order__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Zamówienie:', 'Order')))]), _vm._v(" " + _vm._s(_vm.order.reference) + "\n      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "om-order__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Imię i nazwisko:', 'Order')))]), _vm._v(" " + _vm._s(_vm.order.firstname + ' ' + _vm.order.lastname) + "\n      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "om-order__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Telefon:', 'Order')))]), _vm._v(" " + _vm._s(_vm.order.phone) + "\n      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "om-order__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Adres e-mail:', 'Order')))]), _vm._v(" " + _vm._s(_vm.order.email) + "\n      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "om-order__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Nr konta bankowego:', 'Order')))]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.editFlags.account_number) ? _c('span', [_c('span', [_vm._v(_vm._s(_vm.order.account_number))]), _vm._v(" "), _c('span', {
    staticClass: "om-small-action",
    on: {
      "click": function($event) {
        _vm.editFlags.account_number = !_vm.editFlags.account_number
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$tr('edytuj', 'Order')) + "\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.editFlags.account_number) ? _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.account_number),
      expression: "order.account_number"
    }],
    staticClass: "om-input om-input--inline",
    attrs: {
      "type": "text",
      "size": _vm.order.account_number ? _vm.order.account_number.length : 1,
      "title": _vm.$tr('Nr konta bankowego', 'Order')
    },
    domProps: {
      "value": (_vm.order.account_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.order, "account_number", $event.target.value)
      }
    }
  }), _vm._v("\n             \n            "), _c('button', {
    staticClass: "om-btn om-btn--inline",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateCustomer({
          account_number: _vm.order.account_number
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$tr('zapisz', 'Order')))])]) : _vm._e()])], 1)]), _vm._v(" "), (_vm.order.products) ? _c('div', {
    staticClass: "om-products"
  }, [_c('table', {
    staticClass: "om-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$tr('Produkty', 'Order')) + " (" + _vm._s(_vm.order.products.length) + ")")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$tr('Cena jednostkowa (brutto)', 'Order')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$tr('Ilość', 'Order')))]), _vm._v(" "), (_vm.isReturn()) ? _c('th', {
    staticClass: "om-text-center"
  }, [_vm._v(_vm._s(_vm.$tr('Informacje o zwrocie', 'Order')))]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.order.products), function(p, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_c('div', {
      staticClass: "flex cen"
    }, [_c('div', {
      staticClass: "om-products__image"
    }, [_c('img', {
      attrs: {
        "src": p.image,
        "alt": p.name
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "om-products__desc fg-20"
    }, [_c('h4', {
      staticClass: "om-products__medium"
    }, [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('h5', {
      staticClass: "om-products__small"
    }, [_vm._v(_vm._s(_vm.$tr('Kod produktu:', 'Order')) + " " + _vm._s(p.reference))]), _vm._v(" "), (p.attributes) ? _c('ul', {
      staticClass: "om-attributes"
    }, _vm._l((p.attributes), function(val, attr) {
      return _c('li', {
        key: attr,
        staticClass: "om-products__small"
      }, [_vm._v("\n                      " + _vm._s(attr) + ": " + _vm._s(val) + "\n                    ")])
    }), 0) : _vm._e()])])]), _vm._v(" "), _c('td', {
      staticClass: "om-std"
    }, [_vm._v(_vm._s(p.price) + " "), _c('span', {
      staticClass: "currency"
    }, [_vm._v(_vm._s(p.currency))])]), _vm._v(" "), _c('td', {
      staticClass: "om-std"
    }, [_vm._v(_vm._s(p.quantity))]), _vm._v(" "), (_vm.isReturn() && key === 0) ? _c('td', {
      staticClass: "om-std om-text-center",
      attrs: {
        "rowspan": _vm.order.products.length
      }
    }, [_c('div', {
      staticClass: "font-normal"
    }, [_vm._v(_vm._s(_vm.$moment(_vm.order.date_return).format('DD.MM.YYYY')) + _vm._s(_vm.$tr('r.', 'Order')))]), _vm._v(" "), _c('div', {
      staticClass: "font-normal"
    }, [_vm._v(_vm._s(_vm.$tr('godz.', 'Order')) + " " + _vm._s(_vm.$moment(_vm.order.date_return).format('HH:mm')))]), _vm._v(" "), _c('div', {
      staticClass: "font-normal"
    }, [_vm._v(_vm._s(_vm.order.store_return.name))])]) : _vm._e()])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "om-vertical-space"
  }), _vm._v(" "), (_vm.isCollect()) ? _c('div', [(_vm.collect_store) ? _c('section', {
    staticClass: "om-section"
  }, [_c('h3', {
    staticClass: "om-subheading"
  }, [_vm._v("\n          " + _vm._s(_vm.$tr('Adres odbioru', 'Order')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "om-text-sc"
  }, [_c('div', [_vm._v(_vm._s(_vm.collect_store.name))]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.$tr('ul.', 'ShopList')) + " " + _vm._s(_vm.collect_store.address.street) + "\n            " + _vm._s(_vm.collect_store.address.house) + "\n            " + _vm._s(typeof _vm.collect_store.address.flat !== 'undefined' && _vm.collect_store.address.flat !== '' ? ("/ " + (_vm.collect_store.address.flat)) : '') + "\n          ")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.collect_store.address.postcode) + " " + _vm._s(_vm.collect_store.address.city))])])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "om-vertical-space"
  }), _vm._v(" "), _c('section', {
    staticClass: "om-section"
  }, [_c('h3', {
    staticClass: "om-subheading"
  }, [_vm._v("\n          " + _vm._s(_vm.$tr('Historia zamówienia:', 'Order')) + "\n        ")]), _vm._v(" "), _c('ul', {
    staticClass: "om-summary"
  }, [_c('li', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "om-summary__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Data złożenia zamówienia:', 'Order')))]), _vm._v(" "), _c('div', {
    staticClass: "om-summary__val"
  }, [_vm._v(_vm._s(_vm.$moment(_vm.order.date).format('DD.MM.YYYY HH:mm:SS')))])]), _vm._v(" "), (typeof _vm.order.date_store_delivery !== 'undefined') ? _c('li', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "om-summary__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Data przyjęcia zamówienia przez sklep stacjonarny:', 'Order')))]), _vm._v(" "), _c('div', {
    staticClass: "om-summary__val"
  }, [_vm._v(_vm._s(_vm.$moment(_vm.order.date_store_delivery).format('DD.MM.YYYY HH:mm:SS')))])]) : _vm._e(), _vm._v(" "), (_vm.order.collected) ? _c('li', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "om-summary__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Data odbioru zamówienia przez klienta:', 'Order')))]), _vm._v(" "), _c('div', {
    staticClass: "om-summary__val"
  }, [_vm._v(_vm._s(_vm.$moment(_vm.order.date_collect).format('DD.MM.YYYY HH:mm:SS')))])]) : _vm._e()])])]) : (_vm.isReturn()) ? _c('div', [_c('section', {
    staticClass: "om-section"
  }, [_c('h3', {
    staticClass: "om-subheading"
  }, [_vm._v("\n          " + _vm._s(_vm.$tr('Podsumowanie zwrotu:', 'Order')) + "\n        ")]), _vm._v(" "), _c('ul', {
    staticClass: "om-summary"
  }, [_c('li', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "om-summary__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Ilość zwróconych produktów:', 'Order')))]), _vm._v(" "), _c('div', {
    staticClass: "om-summary__val"
  }, [_vm._v(_vm._s(_vm.returnSummary.quantity))])]), _vm._v(" "), _c('li', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "om-summary__lab"
  }, [_vm._v(_vm._s(_vm.$tr('Wartość zwróconych produktów:', 'Order')))]), _vm._v(" "), _c('div', {
    staticClass: "om-summary__val"
  }, [_vm._v(_vm._s(_vm.$helper.displayPrice(_vm.returnSummary.value, _vm.returnSummary.currency)))])])])]), _vm._v(" "), _c('section', {
    staticClass: "om-section"
  }, [_c('h3', {
    staticClass: "om-subheading"
  }, [_vm._v("\n          " + _vm._s(_vm.$tr('Zwrot zrealizowany:', 'Order')) + "       "), _c('radio', {
    attrs: {
      "disabled": _vm.return_completed,
      "variant": "check",
      "items": [{
        name: 'Zrealizowany',
        value: 1
      }],
      "initial-value": _vm.order.confirmed
    },
    on: {
      "change": _vm.confirmReturn
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "om-vertical-space"
  })]) : (_vm.notFound) ? _c('div', [_vm._v("\n    " + _vm._s(_vm.$tr('Brak szczegółów zamówienia', 'Order')) + "\n  ")]) : _c('div')]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5463ee53","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/OrderForCentral.vue
// module id = 281
// module chunks = 1